import React from "react";
import { Link } from "react-router-dom";

const SideBar = (props) => {
  return (
    <div className="list-group sidebar mt-5">
      <Link
        to="/~atanu.metya/publications/refereedJournal"
        className={props.refereedJournal ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action"}
        aria-current="true"
      >
        Refereed Journal
      </Link>
      <Link to="/~atanu.metya/publications/books" className={props.books ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action"}>
      Books and Book Chapters
      </Link>
      <Link to="/~atanu.metya/publications/conference" className = {props.conference ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action"}>
      Invited and Conference Talks
      </Link>
    </div>
  );
};

export default SideBar;
